import { FC } from 'react'

import { RadioGroup, UsPhoneLabel } from 'ui/components'
import { Info, InfoSet } from 'ui/components/Info'
import { Col, Row } from 'ui/themes/globalStyles'

import { RelationshipDetailsProps } from './RelationshipDetailsProps'

export const RelationshipDetails: FC<RelationshipDetailsProps> = ({ applicationRelationship }) => {
  const {
    companyName,
    entityLegalName,
    dba,
    companyPhone,
    companyWebsite,
    description,
    questionnaire: {
      useDBA: { question, answer }
    }
  } = applicationRelationship

  return (
    <InfoSet legend="Relationship Details">
      <Row>
        <Col>
          <Info label="Company Name">{companyName}</Info>
        </Col>
        <Col>
          <Info label="Entity Legal Name">{entityLegalName}</Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label={question}>
            <RadioGroup
              readonly
              value={answer}
              name=""
              data={[
                { value: true, label: 'Yes' },
                { value: false, label: 'No' }
              ]}
            />
          </Info>
        </Col>
        {answer && (
          <Col>
            <Info label="DBA">{dba}</Info>
          </Col>
        )}
      </Row>
      <Row>
        <Col>
          <Info label="Phone">
            <UsPhoneLabel value={companyPhone} />
          </Info>
        </Col>
        <Col>
          <Info label="Website">{companyWebsite}</Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label="Description">{description}</Info>
        </Col>
      </Row>
    </InfoSet>
  )
}
